import "../../../styles/leaveManagement.css";
import ApproveDeclineLeave from "../ApproveDeclineLeave";
import EmployeeLeaveMoreDetails from "../EmployeeLeaveMoreDetails";
import UpdateLeaveStatus from "../UpdateLeaveStatus";

export default function LeaveTableModals({
  showEmployeeLeaveDetails,
  showUpdateLeaveDetails,
  showApproveDeclinePage,
  selectedEmployeeData,
  selectedCompany,
  setShowEmployeeLeaveDetails,
  setShowUpdateLeaveDetails,
  setSelectedEmployeeData,
  setShowApproveDeclinePage,
}) {
  return (
    <>
      {showEmployeeLeaveDetails && (
        <div className="popup-overlay">
          <div className="popup-content">
            <EmployeeLeaveMoreDetails
              employeeData={selectedEmployeeData}
              setShowEmployeeLeaveDetails={setShowEmployeeLeaveDetails}
              selectedCompany={selectedCompany}
            />
          </div>
        </div>
      )}

      {showUpdateLeaveDetails && (
        <div className="popup-overlay">
          <div className="popup-content">
            <UpdateLeaveStatus
              employeeData={selectedEmployeeData}
              setShowUpdateLeaveDetails={setShowUpdateLeaveDetails}
              setSelectedEmployeeData={setSelectedEmployeeData}
            />
          </div>
        </div>
      )}

      {showApproveDeclinePage && (
        <div className="popup-overlay">
          <div className="popup-content">
            <ApproveDeclineLeave
              employeeData={selectedEmployeeData}
              setShowApproveDeclinePage={setShowApproveDeclinePage}
              selectedCompany={selectedCompany}
            />
          </div>
        </div>
      )}
    </>
  );
}
